var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVueicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 59,
    viewBox: "0 0 69 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.7125 0.44458H68.1875L34.5 58.5555L0.8125 0.44458H26.5834L34.5 13.9196L42.2481 0.44458H54.7125Z",
    fill: "#41B883"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.8125 0.44458L34.5 58.5555L68.1875 0.44458H54.7125L34.5 35.3111L14.1191 0.44458H0.8125Z",
    fill: "#41B883"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1191 0.44458L34.5001 35.4796L54.7126 0.44458H42.2482L34.5001 13.9196L26.5835 0.44458H14.1191Z",
    fill: "#35495E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVueicon);
export default __webpack_public_path__ + "static/media/vueicon.b42d1ccf0f3e2fc899477521cbde2b24.svg";
export { ForwardRef as ReactComponent };